/**
 * Team List Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Team List guide.
 */
export const teamListTourConfig = {
  id: 'team-list-onboarding',
  storageKey: 'triad_tour_team_list_completed',
  steps: [
    {
      id: 'team-add-btn',
      target: '[data-tour="team-add-btn"], [data-tour="crud-add-btn"]',
      titleKey: 'tour.teamList.addTitle',
      descriptionKey: 'tour.teamList.addDesc',
      position: 'bottom',
      align: 'end'
    },
    {
      id: 'team-search-input',
      target: '[data-tour="team-search-input"], [data-tour="crud-search-input"]',
      titleKey: 'tour.teamList.searchTitle',
      descriptionKey: 'tour.teamList.searchDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'team-table',
      target: '[data-tour="team-table"], [data-tour="crud-table"]',
      titleKey: 'tour.teamList.tableTitle',
      descriptionKey: 'tour.teamList.tableDesc',
      position: 'top',
      align: 'center'
    }
  ]
};

export default teamListTourConfig;
